export default {
  home: {
    title: 'USFans Spreadsheet — Find, Compare & Explore USFans Resources',
    metaDescription: 'Explore USFans Spreadsheet resources, product categories, buying guides, shipping information and safety tips — organized in one easy-to-use multilingual hub.',
    hero: {
      badge: 'Independent resource hub',
      h1: 'USFans Spreadsheet — Find, Compare & Explore USFans Resources',
      subtitle: 'Explore the latest USFans Spreadsheet resources, product guides, buying tips, shipping information and safety resources — organized in one easy-to-use hub.',
      trust1: 'Organized Resources',
      trust2: 'Regular Updates',
      trust3: 'Multilingual Guides',
      trust4: 'Safety Information',
      dropdownLabel: 'Choose a category',
      dropdownPlaceholder: 'Select a product category',
    },
    why: {
      title: 'Why use the USFans Spreadsheet?',
      text: 'Finding useful USFans resources can be difficult when information is scattered across different websites, communities and posts. Our goal is to organize the most useful USFans Spreadsheet information into clear categories, practical guides and easy-to-understand comparisons.',
    },
    categories: {
      title: 'Browse product categories',
      subtitle: 'Jump straight to the category you need on the main website.',
      viewAll: 'View all categories',
    },
    topics: {
      title: 'Popular USFans topics',
      subtitle: 'The topics people search for most.',
      topic1Title: 'USFans Spreadsheet',
      topic1Desc: 'The complete overview of the spreadsheet, categories and links.',
      topic2Title: 'USFans Review',
      topic2Desc: 'What to know before you use USFans, with pros and cons.',
      topic3Title: 'USFans Shipping Cost',
      topic3Desc: 'Understand rates, delivery times and ways to save.',
      topic4Title: 'USFans Coupon',
      topic4Desc: 'How to find current coupons and discount offers.',
      topic5Title: 'USFans Discount Code',
      topic5Desc: 'A practical look at where discount codes appear.',
      topic6Title: 'USFans Warehouse',
      topic6Desc: 'How the warehouse, storage and QC process works.',
      topic7Title: 'USFans Legit',
      topic7Desc: 'Safety checks and what to verify before purchasing.',
    },
    guides: {
      title: 'Latest guides',
      subtitle: 'Original, in-depth articles to help you get more from the USFans Spreadsheet.',
      readMore: 'Read the guide',
      articleTitle: 'What Is the USFans Spreadsheet? A Complete Guide',
      articleCategory: 'Guide',
      articleReadingTime: '6 min read',
      articleSummary: 'A clear, original overview of how the USFans Spreadsheet works, how to browse categories, compare products and shop with confidence.',
    },
    pillars: {
      title: 'Pillar articles',
      subtitle: 'In-depth guides covering the topics that matter most, updated regularly.',
      label: 'Guide',
      minRead: 'min read',
      readMore: 'Read the guide',
      items: {
        spreadsheetGuide: { title: 'What Is a USFans Spreadsheet?', summary: 'A clear overview of what the spreadsheet is and how it is organized.' },
        howToUse: { title: 'How to Use the USFans Spreadsheet', summary: 'Step-by-step tips for browsing categories and finding products fast.' },
        directory: { title: 'USFans Spreadsheet Directory', summary: 'How the directory groups products and links for easier browsing.' },
        review: { title: 'USFans Review: Pros and Cons', summary: 'A balanced look at the strengths and things to watch out for.' },
        shippingCost: { title: 'USFans Shipping Cost Guide', summary: 'Understand rates, delivery times and practical ways to save.' },
        warehouse: { title: 'USFans Warehouse Guide', summary: 'How storage, QC and shipping work behind the scenes.' },
        coupon: { title: 'USFans Coupon & Discount Code Guide', summary: 'Where to find current coupons and discount codes.' },
        legit: { title: 'Is USFans Legit?', summary: 'Safety checks and what to verify before you buy.' },
        buyingGuide: { title: 'USFans Buying Guide', summary: 'A practical checklist for a smooth and informed purchase.' },
        safety: { title: 'USFans Safety Guide', summary: 'How to verify links, payments and stay safe online.' },
      },
    },
    safety: {
      title: 'Use USFans resources more safely',
      text: 'Always verify links, current prices, shipping information and seller details before making a purchase. Never share passwords, authentication codes or sensitive payment information with unknown websites.',
      cta: 'Read the safety guide',
      check1: 'Verify the domain',
      check2: 'Check HTTPS',
      check3: 'Never share passwords',
      check4: 'Never share verification codes',
    },
    faq: {
      title: 'Frequently asked questions',
      subtitle: 'Quick answers to common questions about the USFans Spreadsheet.',
      q1: 'What is the USFans Spreadsheet?',
      a1: 'The USFans Spreadsheet is an organized list of US fashion and streetwear products and shopping links, grouped into clear categories like shoes, hoodies, t-shirts and accessories so you can find what you need faster.',
      q2: 'Is the USFans Spreadsheet free to use?',
      a2: 'Browsing the categories and guides is free. Always verify current prices, shipping details and seller information on the main website before making a purchase.',
      q3: 'How do I find a specific product?',
      a3: 'Use the category dropdown or the category buttons on this page to jump straight to the relevant section of the main website.',
      q4: 'Is USFans legit?',
      a4: 'We always recommend verifying links, checking HTTPS, and confirming seller and payment details yourself before purchasing. Treat any unfamiliar website with care.',
      q5: 'What should I check before buying?',
      a5: 'Check current prices, shipping costs and times, return policies, and the seller details. Information can change, so verify the latest details on the main website.',
      q6: 'How often is the information updated?',
      a6: 'We aim to keep guides and categories up to date, but always confirm current listings and prices on the main website before you buy.',
    },
    final: {
      title: 'Ready to explore USFans Spreadsheet resources?',
      text: 'Start with the USFans Spreadsheet hub and discover guides, comparisons, reviews, shipping information and practical resources.',
    },
  },
};